// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"395":"4b77ffe4","821":"4c81ea3e","867":"4f8d341f"}[chunkId] + ".css";
};